export default {
  // 页面标题和描述
  title: '一个人 + AI，每月落地 500+ 达人合作',
  description: '创建账号，一键连接全球优质创作者，开启高效品牌合作。',
  
  referralSource: {
    label: '您是通过什么渠道了解到 AhaCreator 的？',
    placeholder: '请选择您了解我们的渠道',
    otherLabel: '其他渠道',
    otherPlaceholder: '请输入您了解我们的渠道',
    otherRequired: '请输入您了解我们的渠道',
    required: '请选择您了解我们的渠道',
    options: {
      tiktok: 'TikTok',
      instagram: 'Instagram',
      youtube: 'YouTube',
      twitter_x: 'Twitter / X',
      linkedin: 'LinkedIn',
      google_search: 'Google Search',
      xiaohongshu: '小红书',
      wechat_official_account: '微信公众号',
      wechat_moments: '微信朋友圈',
      wechat_channels: '微信及腾讯旗下平台（公众号、朋友圈、视频号、小程序等）',
      douyin: '抖音',
      friend_referral: '朋友推荐',
      sales_contact: '销售联系',
      other: '其他',
    },
  },
  // 表单字段标签
  formLabels: {
    name: '姓名',
    firstName: '名',
    lastName: '姓',
    email: '邮箱（建议使用工作邮箱）',
    website: '公司官网或产品',
    budget: '您的每月达人营销预算',
    industry: '您的所属行业',
    goal: '本次活动目标',
    location: '您本人位于哪里',
    organizationLocation: '您的组织位于哪里',
    phone: '手机号',
    wechat: '微信',
    contact: '联系方式',
    linkedin: 'LinkedIn',
    note: '有助于准备会议的任何信息（可选）'
  },
  
  // 表单占位符
  placeholders: {
    name: '请输入您的全名',
    firstName: '请输入名字',
    lastName: '请输入姓氏',
    email: '例如：alex.johnson@company.com',
    website: '例如：www.company.com公司官网、产品链接或产品名称',
    budget: '选择预算区间',
    industry: '选择所属行业',
    goal: '选择活动目标',
    country: '选择国家/地区',
    phone: '请输入手机号',
    code: '验证码',
    wechat: '请输入微信号',
    contact: 'LinkedIn / WhatsApp / Line / Telegram / Slack',
    linkedin: '请输入 LinkedIn 主页链接',
    note: '您想让我们了解的任何信息…'
  },

  // 表单提示
  hints: {
    website:
      '请优先填写公司官网；如没有官网，可填写产品链接（如亚马逊链接）或直接填写产品名称。',
  },
  
  // 表单验证消息
  validation: {
    nameRequired: '请输入您的姓名',
    firstNameRequired: '请输入名',
    lastNameRequired: '请输入姓',
    emailRequired: '请输入您的工作邮箱',
    emailInvalid: '请输入有效的工作邮箱',
    websiteRequired: '请输入您的公司网站',
    websiteInvalid: '请输入有效的网站 URL',
    budgetRequired: '请选择营销预算',
    budgetTooLow: 'AhaCreator 适用于 2,000 美元或以上的预算。一旦 AhaCreator Lite 支持较小预算，我们会立即联系您。',
    industryRequired: '请选择所属行业',
    goalRequired: '请选择活动目标',
    countryRequired: '请选择国家/地区',
    phoneRequired: '请输入手机号',
    phoneInvalid: '手机号格式不正确',
    phoneMustStartWithPlus: '手机号必须以 + 开头',
    phoneInvalidFormat: '手机号格式不正确',
    phoneCountryCodeMismatch: '{region} 的手机号必须以 {countryCode} 开头',
    phoneCountryFormatInvalid:
      '{region} 手机号格式不正确。示例：{example}',
    codeRequired: '请输入验证码',
    codeLength: '验证码须为 6 位数字',
    codeIncorrect: '请输入正确的验证码',
    wechatRequired: '请输入微信号',
    contactRequired: '请输入您的联系方式'
  },
  
  // 按钮文本
  buttons: {
    sendCode: '发送验证码',
    resend: '重新发送',
    resendCountdown: '重新发送 {countdown}s',
    submit: '提交',
    chooseDateTime: '选择日期和时间',
    loading: '加载中…',
    continue: '继续'
  },
  
  // 其他文本
  required: '*',
  source: '平台',
  
  // 预算选项
  budgetOptions: {
    lessThan2000: '少于 2,000 USD / 月',
    '2000To10000': '2,000 - 10,000 USD / 月',
    '10000To50000': '10,000 - 50,000 USD / 月',
    moreThan50000: '超过 50,000 USD / 月'
  },
  
  // 行业选项
  industryOptions: {
    aiSaaSApp: 'AI / SaaS / App',
    ecommerce: '电商',
    agency: '广告公司或代理商（聚焦 AI / SaaS / App / 电商）',
    beauty: '美妆',
    foodBeverage: '餐饮',
    others: '其他'
  },
  
  // 活动目标选项
  campaignGoalOptions: {
    brandAwareness: '品牌曝光',
    brandAwarenessAndPerformance: '品牌曝光 + 效果转化',
    performanceOnly: '销售（暂不适合 AhaCreator）'
  }
};
